<template>
    <div class="text-start ms-3 ms-md-5" :class="{ 'd-flex ms-3 me-3 me-lg-5': includeTerritories('usa') }">
        <p v-if="!hide && !forceHide" class="back-button" @click="click">
            <i class="fal fa-angle-left"></i> {{ $t('form.backButton') }}
        </p>
        <LegalHeaderBar location="WizardHeader" />
    </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default {
    props: ['forceHide'],
    data() {
        return {
            router: useRouter(),
            route: useRoute(),
            store: useStore(),
        }
    },
    methods: {
        click() {
            if (this.getBackRoute) {
                this.trackEvent('event', {
                    eventCategory: 'back-button',
                    eventAction: 'click',
                    eventLabel: this.getBackRoute.path,
                })

                this.router.replace({ name: this.getBackRoute.name })
            }
        },
    },
    computed: {
        hide() {
            return this.store.state.apply.currentRouteStep?.hideBack || !this.getBackRoute
        },
        getPreviousStep() {
            return this.store.getters.getStepBefore(this.store.state.apply.currentRouteStep)
        },
        getBackRoute() {
            let backRoute = this.getPreviousStep?.route

            // go back to summary page if there was one
            if (this.store.state.apply.has.fullSummary) {
                backRoute = this.store.getters.stepViaRouteName('apply.summary')?.route
            }

            return backRoute
        },
    },
}
</script>

<style lang="scss" scoped>
.back-button {
    color: var(--wizard-back-button-color);
    cursor: pointer;
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    margin-bottom: 0px;
    text-transform: capitalize;
    user-select: none;
}
</style>
